<script lang="ts">
    export let initState: boolean = false;
    export let onStateChanged: ((state: boolean) => any) | undefined = undefined;
    export let style: string = '';

    let state: boolean = initState;
    function onClick() {
        state = !state;
        if (onStateChanged) { onStateChanged(state) };
    }
</script>


<span id="btn-chevron" on:click={onClick} style={style}>
    {#if state}&dtrif;{:else}&rtrif;{/if}
</span>

<style>
    #btn-chevron {
        width: 16px;
        height: 16px;
        user-select: none;
        -webkit-user-select: none;
    }
</style>
